/** A project's typical shift hours, the most a downtime day pays on it. Mirrors the server's `TypicalShiftHoursIn`: above 0, at most 24, at most two decimals. */
export function parseTypicalHours(text: string): number | null {
  const trimmed = text.trim().replace(',', '.')
  if (!/^\d{1,2}(\.\d{1,2})?$/.test(trimmed)) return null
  const value = Number(trimmed)
  if (!(value > 0) || value > 24) return null
  return value
}

/** The server's Decimal arrives as a string ("11.00"); show it as "11", and nothing when it is unknown. */
export function typicalHoursText(value: number | string | null | undefined): string {
  if (value == null || value === '') return ''
  const n = Number(value)
  return Number.isFinite(n) ? String(n) : ''
}

/** The `product_service.type_of` value that tags a row as a project. */
export const PROJECT_TYPE_OF = 'Project'

/**
 * The card lists ONLY products carrying the project tag (exact `type_of === 'Project'` match).
 * ⚠️ A filter on the editor, not on the pay rule: `services/payroll.py` still caps a downtime day at `typical_shift_hours` whatever the row's type.
 * Active first, then by title.
 */
export function projectProducts<T extends { type_of: string; is_active: boolean; title: string }>(
  products: readonly T[] | undefined,
): T[] {
  return (products ?? [])
    .filter((p) => p.type_of === PROJECT_TYPE_OF)
    .sort((a, b) => Number(b.is_active) - Number(a.is_active) || a.title.localeCompare(b.title))
}
